module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAQlBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8fa6fT////n8Phgns7z+Pt4rdaFtdq20unO4fBUl8udxOHC2uxsptKRHn1pAAAACHRSTlMAYL//ACDP71kzCuAAAADZSURBVHgB7dgNaoQwFEXh/JvcSSZx1P1vdXQFLXigoXgW8IGo8fnMlXX+Rs6GMxNCTP5mKV5QXPztlnhCyQOlYKxHssYxkDMe6l9CD5QpqGQI0qtCkNobgqROQRoUpDVDkMoHgtQqBEmdgrRRkEaGIJUMQXpVCFJ7/w7Sz3UK0qAgrRmCVD4QpFYhSOoUpI2CNKaA+Etrnb/9MzyQe57rpe3QwXbMddRSh/+Y6wPZ+lxDBDXW7NCgNeYaRtvxJwM78AsB9EAPhC1ZsLUPtojiVmPYsu6MWB9+Aaj2VreWk7uuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/27a1.png
// module id = 1412
// module chunks = 0